import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Planogram } from "./model/planogram";
import { Constants } from '../../../../app.constant';
import { PlanogramV2Service } from 'app/pages/cms/components/capsuline/planogram-v2/services';
import { CampaignService } from 'app/pages/cms/components/campaign/services/campaign.service';
import { MediaLibraryServices } from 'app/pages/cms/components/media-library/services/mediaLibraryServices';
import * as _ from 'lodash';

@Component({
  selector: 'app-capsuling-preview',
  templateUrl: './capsuling-preview.component.html',
  styleUrls: ['./capsuling-preview.component.scss']
})
export class CapsulingPreviewComponent implements OnInit {

  public planogram: Planogram;
  public error: string = '';
  public errorObj: any = [];
  public _isActive: any = [];
  public _isChilds: any = [];
  public campagnList = [];
  public allCampaignList = [];
  public showPreview = false;
  public campaignToPreview;
  public campaignString;
  public currentCampaignIndex;
  public showDisclaimer = false;
  public dateFormate = Constants.Var.dateFormate;
  public timestampFormate = Constants.Var.timestampFormate;
  public planogramId: number
  public campaign;
  public showVideoDisclaimer: boolean = false;
  public deviceData = []
  constructor(
    public activeModal: NgbActiveModal,
    private PlanogramV2Service: PlanogramV2Service,
    private _campaignService: CampaignService,
    private _mediaLibraryServices: MediaLibraryServices,
  ) { }

  ngOnInit() {
    console.log(this.planogram, "--------");
    let planogram: any = this.planogram
    this.planogramId = this.planogram.planogramId;
    this.getAllCampaignsInScheduler(this.planogramId)
    this.deviceData = planogram.deviceData

  }
  public closeModal() {
    this.activeModal.close();
  }
  public getAllCampaignsInScheduler(planogramId: number) {
    this.PlanogramV2Service.getAllCampaignsInScheduler(planogramId).subscribe(
      res => {
        if (res) {
          this.allCampaignList = res
        }
      })

  }
  convertTimeFormat(time: string): string {
    const parts = time.split(':')
    const hours = parts[0];
    const minutes = parts[1];
    return hours + ':' + minutes;
  }
  previewCampaignImage(layoutId) {
    this.campaign = null
    if (/^[0-9]+$/.test(layoutId)) {
      this._campaignService.getCampaignFullDetails(layoutId, this._mediaLibraryServices)
        .subscribe(res => {
          this.campaign = res;
          _.forEach(this.campaign.regions, (data) => {
            _.forEach(data.globalRegionContentPlaylistContents, (data) => {
              if (data.contentType == "URL") {
                this.showDisclaimer = true;
              }
              if (data.contentType == "VIDEO") {
                let mediaDimensions = data.mediaDimension.split("x");
                if (mediaDimensions[0] > 3840) {
                  this.showVideoDisclaimer = true;
                } else if (mediaDimensions[1] > 2160) {
                  this.showVideoDisclaimer = true;
                }
              }

            });

          });
          $('#previewCampaign').modal('show')
          $('#parentContainer').css({ height: "500px", overflow: "auto" })
        },
          err => {
            if (err.error.code == 1223) {
              // this._err.renderError({ errMsg: "Campaign doesn't exist" });
              // this.goToList();
            }
            this.errorObj = err.error
            if (this.errorObj.name == '400') {
              this.errorObj.result = null;
              this.errorObj.message = "Invalid Request";
            }
          });
    }
  }
  closeModalPreview() {
    $('#previewCampaign').modal('hide')
    $('#parentContainer').css("height", "auto")
    $('#parentContainer').removeProp("overflow")
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/capsuling-preview/capsuling-preview.component.ts